// extracted by mini-css-extract-plugin
module.exports = {"mobile":"768px","tablet":"1024px","laptop":"1200px","desktop":"1512px","xl":"1800px"};